module.exports = __webpack_public_path__ + "img/huangguan.ddc296eb.svg";